import { render, staticRenderFns } from "./Checker.vue?vue&type=template&id=63cf3f88&lang=pug"
import script from "./Checker.vue?vue&type=script&lang=js"
export * from "./Checker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports